import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles.css';
import './styles/global.css';

// Eski service worker kayıtlarını oturumda bir kez temizle (cache silme — statik dosyalar tarayıcıda kalsın)
if ('serviceWorker' in navigator && !sessionStorage.getItem('sw_cleanup_done')) {
  sessionStorage.setItem('sw_cleanup_done', '1');
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister().catch(() => {});
    });
  }).catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);


